import React from 'react'
import { Link } from 'react-router-dom'
import { DatumItem } from '../helper/models/getProducts'
import { addToCart } from '../helper/services/cart'
import { ImageProcess } from '../helper/services/imageProcess'

const imageProcess = new ImageProcess()
const Cart = ({
  update,
  showCheckOut,
}: {
  update: boolean
  showCheckOut: boolean
}) => {
  const [render, reRender] = React.useState(1)
  let inx = 2
  console.log(addToCart.get().length)

  return (
    <div>
      {showCheckOut && addToCart.get().length > 0 && (
        <div className="p-3 mt-3 text-center text-white rounded-lg bg-cyan-600">
          <p className="">Cart</p>
        </div>
      )}
      <div className="text-white">
        {render >= 1 &&
          addToCart.get().map((item) => (
            <div
              className="justify-around p-2 mt-2 overflow-hidden rounded-lg min-w-fit bg-cyan-600"
              key={item.product.images[0]}
            >
              <img
                src={imageProcess.process(item.product.images[0])}
                alt={item.product._id}
                key={item.product._id}
                className="inline-block rounded-lg w-14 h-14"
              />
              <p className="inline-block ml-2">{item.product.name}</p>
              <div className="flex p-1 mt-2 space-x-2 bg-black border-2 rounded-lg w-min">
                <span
                  className="inline-block px-1 cursor-pointer"
                  onClick={(e) => remove(item.product.objectId)}
                >
                  -
                </span>
                <p>{item.count}</p>
                <span
                  className="inline-block px-1 cursor-pointer"
                  onClick={(e) =>
                    add(item.product, item.restaurantId, item.groupId)
                  }
                >
                  +
                </span>
              </div>
            </div>
          ))}
      </div>
      {showCheckOut && addToCart.get().length > 0 && (
        <Link to={'/checkout'}>
          <div className="p-3 mt-2 text-center text-white rounded-lg bg-cyan-600">
            <p className="">Checkout</p>
          </div>
        </Link>
      )}
    </div>
  )
  async function remove(id: string) {
    inx++
    reRender(inx)
    await addToCart.reduce(id)
    inx++
    reRender(inx)
    inx++

    reRender(inx)
    console.log(addToCart.get().length)

    return
  }
  async function add(item: DatumItem, restaurantId: string, groupId: string) {
    inx++
    reRender(inx)
    await addToCart.add(item, restaurantId, groupId)
    inx++
    reRender(inx)
    inx++

    reRender(inx)
    return
  }
}

export default Cart
